var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Icon, Input, Loader, Message, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { debounce } from "../kit/automated-pro/EditKitForm";
import { getWithAuthn, postJsonWithAuthn, postWithAuthn } from "../RequestHelpers";
var CreateOrderForUser = /** @class */ (function (_super) {
    __extends(CreateOrderForUser, _super);
    function CreateOrderForUser(props) {
        var _this = _super.call(this, props) || this;
        _this.debouncedSearch = debounce(function (_, data) {
            var query = data.value;
            if (query.length >= 2) {
                _this.setState({
                    loading: true,
                    error: false
                }, function () { return getWithAuthn("/admin/users/search?q=" + encodeURIComponent(query))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true,
                            results: []
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            results: resp.users
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't search users: " + rej);
                }); });
            }
            else {
                _this.setState({ results: [] });
            }
        }, 300);
        _this.onQueryChange = function (event, data) {
            _this.setState({ query: data.value });
            _this.debouncedSearch(event, data);
        };
        _this.createStarterKitOrder = function (userId) {
            _this.setState({
                loading: true,
                error: false
            }, function () {
                var _a, _b, _c, _d, _e, _f;
                postJsonWithAuthn("/admin/orders/create-cish-starter-kit-for-user/id/" + encodeURIComponent(userId), JSON.stringify({
                    _type: "automated-pro",
                    protocolTypeId: (_b = (_a = _this.props.starterKitFormState) === null || _a === void 0 ? void 0 : _a.protocolType) === null || _b === void 0 ? void 0 : _b.id,
                    libraryOrganismId: (_d = (_c = _this.props.starterKitFormState) === null || _c === void 0 ? void 0 : _c.libraryOrganism) === null || _d === void 0 ? void 0 : _d.id,
                    enzymeCompatibilityId: (_f = (_e = _this.props.starterKitFormState) === null || _e === void 0 ? void 0 : _e.enzymeCompatibility) === null || _f === void 0 ? void 0 : _f.id
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            orderId: resp.orderId
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't create order for user: " + rej);
                });
            });
        };
        _this.createManualStarterKitOrder = function (userId) {
            _this.setState({
                loading: true,
                error: false
            }, function () {
                postJsonWithAuthn("/admin/orders/manual-starter-kit/id/" + encodeURIComponent(userId), JSON.stringify(_this.props.manualStarterKitFormState))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            orderId: resp.orderId
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't create order for user: " + rej);
                });
            });
        };
        _this.onCreateOrder = function (userId) {
            _this.setState({
                loading: true,
                error: false
            }, function () {
                postWithAuthn("/admin/orders/create-for-user/id/" + encodeURIComponent(userId))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            orderId: resp.orderId
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't create order for user: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            query: '',
            results: []
        };
        return _this;
    }
    CreateOrderForUser.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { as: Form },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(Form.Field, null,
                    React.createElement("label", null, "Search by user name, email or ID"),
                    React.createElement(Input, { placeholder: 'Type at least 2 characters...', onChange: this.onQueryChange, value: this.state.query, autoFocus: true })),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Name"),
                            React.createElement(Table.HeaderCell, null, "Id"),
                            React.createElement(Table.HeaderCell, null, "Pick"))),
                    this.state.results.length === 0 ? React.createElement("em", null, "No results") : this.state.results.map(function (u, index) {
                        var selectUser = function () {
                            _this.setState({
                                user: u
                            });
                        };
                        return React.createElement(Table.Row, { key: index },
                            React.createElement(Table.Cell, null,
                                React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + encodeURIComponent(u.id), target: '_blank' }, u.name)),
                            React.createElement(Table.Cell, null, u.id),
                            React.createElement(Table.Cell, { style: { height: '3rem' } }, _this.state.user !== undefined && _this.state.user.id === u.id
                                ? React.createElement(Icon, { name: 'check' })
                                : React.createElement(Button, { icon: 'check', size: 'tiny', onClick: selectUser })));
                    })),
                React.createElement("p", null,
                    "Selected user: ",
                    this.state.user === undefined
                        ? '-'
                        : React.createElement(React.Fragment, null,
                            this.state.user.name,
                            " (",
                            this.state.user.id,
                            ")")),
                this.state.user !== undefined
                    && (function (user) {
                        var clickHandler = function () {
                            if (_this.props.starterKitFormState) {
                                _this.createStarterKitOrder(user.id);
                            }
                            else if (_this.props.manualStarterKitFormState) {
                                _this.createManualStarterKitOrder(user.id);
                            }
                            else {
                                _this.onCreateOrder(user.id);
                            }
                        };
                        return React.createElement("p", null,
                            React.createElement(Button, { disabled: _this.state.orderId !== undefined, icon: 'magic', label: "Create order for " + user.name, labelPosition: 'left', onClick: clickHandler, positive: true }));
                    })(this.state.user),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "An error occurred."),
                this.state.orderId &&
                    React.createElement(Message, { positive: true },
                        "Order ",
                        React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + encodeURIComponent(this.state.orderId) }, this.state.orderId),
                        " created.")));
    };
    return CreateOrderForUser;
}(React.PureComponent));
export default CreateOrderForUser;
//# sourceMappingURL=CreateOrderForUser.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CreateOrderForUser.js
// module id = 305
// module chunks = 0